import React from "react";
import Chip from "../kit/Chip";
import "./DateFilterIndicator.css";
import { isDefaultDateFilter, defaultDate } from "../../util/eventUtils";

const DateFilterIndicator = ({ 
  dateFilter, 
  searchQuery = "",
  className = "",
  style = {},
  onClick
}) => {
  // Format the date filter for display
  const formatDateFilter = (filter) => {
    // If filter is null or undefined, use the default date
    if (!filter) {
      filter = defaultDate;
    }
    
    // Handle string-based filters (now, soon, later, late night)
    if (typeof filter === 'string') {
      return filter;
    }
    
    // Handle object-based filters with start/end dates
    let startDate, endDate;
    
    // Handle different date formats
    if (filter.start) {
      startDate = filter.start;
    } else if (filter.startDate) {
      startDate = new Date(filter.startDate);
    }
    
    if (filter.end) {
      endDate = filter.end;
    } else if (filter.endDate) {
      endDate = new Date(filter.endDate);
    }
    
    if (startDate) {
      // Use locale-specific format but remove leading zeros and replace / with .
      const startFormatted = startDate.toLocaleDateString(undefined, {
        day: 'numeric',
        month: 'numeric'
      }).replace(/\//g, '.');
      
      if (endDate && startDate.toLocaleDateString() !== endDate.toLocaleDateString()) {
        const endFormatted = endDate.toLocaleDateString(undefined, {
          day: 'numeric',
          month: 'numeric'
        }).replace(/\//g, '.');
        return `${startFormatted} - ${endFormatted}`;
      }
      
      return startFormatted;
    }
    
    return null;
  };

  const formattedFilter = formatDateFilter(dateFilter);
  
  // Hide if there's no formatted filter
  if (!formattedFilter) return null;
  
  // Hide if there's a search query AND the date filter is the default date
  const hasSearchQuery = searchQuery && searchQuery.trim() !== "";
  
  // Check if the current filter is the default date
  // If dateFilter is null, it means default date is being used
  let isDefault = false;
  if (!dateFilter) {
    // No date filter set means default is being used
    isDefault = true;
  } else if (typeof dateFilter !== 'string' && dateFilter.start && dateFilter.end) {
    // Check if the set date filter matches the default
    isDefault = isDefaultDateFilter(dateFilter);
  }
  
  if (hasSearchQuery && isDefault) {
    return null;
  }

  // Not clickable = plain label (Badge look); clickable = Chip that opens the date filter
  if (!onClick) {
    return (
      <span className={`inyc-badge date-filter-indicator ${className}`} style={style} title={`Current date filter: ${formattedFilter}`}>
        {formattedFilter}
      </span>
    );
  }

  return (
    <Chip
      className={`date-filter-indicator ${className}`}
      style={style}
      title={`Change date filter: ${formattedFilter}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick(e);
      }}
    >
      {formattedFilter}
    </Chip>
  );
};

export default DateFilterIndicator;
